import React, { useEffect } from 'react'
import { Route, Switch, useLocation, useParams, useRouteMatch } from 'react-router-dom'
import { Footer, Loader, OrderProducts, useOrdersHistory } from '../../components'
import { OrderFiles } from '../../components/OrderFiles'
import { NotFound404 } from '../NotFound404'
import { OrderDetailContext } from './OrderDetailContext'
import { Header } from './Header'
import { graphql, useFragment } from '../../gql'
import { useGQLQuery } from '../../hooks/GQLUtilityHooks'
import { OrderDetail_OrderFragmentFragmentDoc } from '../../gql/graphql'
import { OrderDetailsInfo } from './OrderDetailsInfo'
import { useQueryClient } from '@tanstack/react-query'

type OrderDetailParams = {
  orderId: string
}

export const OrderDetail: React.FC<any> = () => {
  const params = useParams<OrderDetailParams>()
  const orderId = parseInt(params?.orderId as string) || 0
  const location: any = useLocation()
  const { path } = useRouteMatch()
  const queryClient = useQueryClient()

  const { refetch, isLoading, isError, data } = useGQLQuery(OrderDetailQuery, ['order'], { id: orderId })
  const order = useFragment(OrderDetail_OrderFragmentFragmentDoc, data)

  const { addOrderToHistory } = useOrdersHistory()

  // Limit cahcing of order history to single page to avoid lags when navigating back
  useEffect(() => {
    console.log('cache updating')
    queryClient.setQueriesData({ queryKey: ['orders'] }, (data: { pages: any[]; pageParams: any[] }) => {
      console.log('clearing cache', { data })
      return {
        pages: (data?.pages || []).slice(0, 1),
        pageParams: (data?.pageParams || []).slice(0, 1),
      }
    })
  }, [])

  useEffect(() => {
    if (!order) return

    addOrderToHistory(order)
  }, [order])

  if (isLoading) return <Loader size="fill-container" />

  if (isError || !order) return <NotFound404 />

  return (
    <OrderDetailContext.Provider value={{ order }}>
      <div className={'h-[100vh] flex flex-col'}>
        <Header />
        <div className={'flex flex-col flex-1 justify-between overflow-y-auto'}>
          <Switch location={location}>
            <Route exact path={path}>
              <OrderProducts />
            </Route>
            <Route path={`${path}/items`}>
              <OrderProducts />
            </Route>
            <Route path={`${path}/info`}>
              <OrderDetailsInfo />
            </Route>
            <Route path={`${path}/files`}>
              <OrderFiles />
            </Route>
          </Switch>
        </div>
        <Footer />
      </div>
    </OrderDetailContext.Provider>
  )
}

const OrderDetailQuery = graphql(`
  query OrderDetail($id: Int!) {
    order(id: $id) {
      data {
        ...OrderDetail_OrderFragment
      }
      errors
    }
  }
`)
